import { faStar } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useUserWalletList } from "~/features/wallet/api/useUserWalletList"
import type { Wallet } from "~/features/wallet/types"
import { useCheckoutContext } from "../contexts/checkout.context";
import { twMerge } from "tailwind-merge";
import { Button } from "./ui/Button";
import { NavLink } from "react-router-dom";

interface WalletSelectItemProps {
    wallet: Wallet;
}

export const WalletPrevicew = ({ pubkey }: { pubkey: string }) => {
    const preview = pubkey.slice(0, 6) + '...' + pubkey.slice(-6);
    return <div className="font-mono text-sm" title={pubkey}>{preview}</div>
}

export const WalletSelectItem = ({ wallet }: WalletSelectItemProps) => {
    const { pubkey, name, is_payout } = wallet;
    const { selectedWallet, setSelectedWallet } = useCheckoutContext();

    const isSelected = selectedWallet === wallet;

    return <div
        className={twMerge(
            "p-2 border border-white/20 rounded hover:bg-white/10 cursor-pointer",
            isSelected && 'outline outline-violet-500'
        )}
        onClick={() => setSelectedWallet(isSelected ? undefined : wallet)}
    >
        <WalletPrevicew pubkey={pubkey} />
        <div className="inline-flex gap-1 items-center text-xs text-white/50">
            {name}
            {is_payout && <FontAwesomeIcon icon={faStar} />}
        </div>
    </div>
}

export const WalletSelect = () => {
    const { data } = useUserWalletList()
    const { selectedWallet, setStep } = useCheckoutContext();

    return <div className="flex flex-col gap-4 select-none">
        <div className="text-2xs uppercase text-center">Web3 asset will be delivered to selected wallet</div>
        {data.map(wallet => <WalletSelectItem key={wallet.pubkey} wallet={wallet} />)}
        <NavLink to="/account#wallets" className="text-2xs uppercase text-center hover:underline">Connect another wallet</NavLink>
        <Button disabled={!selectedWallet} onClick={() => setStep(s => s + 1)}>SELECT</Button>
    </div>
}